import { render, staticRenderFns } from "./VCarousel.vue?vue&type=template&id=448a2717&"
import script from "./VCarousel.vue?vue&type=script&lang=js&"
export * from "./VCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports